import { useState } from "react";
import "../../CSS/regoCheck.css";
import { Modal } from 'react-bootstrap';
import userSession from "../../Constant/auth";
import { APP_SERVICES_URL, PREPAY, IOU, STOLEN_PLATE } from "../../Constant/constant";
import axios from "axios";

const RegoCheckModal = ({ show, onHide }) => {
    const { CustID, authHeader } = userSession;
    const [responseType, setResponseType] = useState(null); // State variable to store response type
    const [licensePlate, setLicensePlate] = useState(""); // State variable to store the license plate entered by the user
    const [error, setError] = useState(""); // State variable to store error message

    // Function to handle input change event
    const handleInputChange = (e) => {
        setLicensePlate(e.target.value);
        setResponseType(null);
        setError(""); // Clear error message on input change
    };


    const handleCheckRego = async () => {
        if (!licensePlate) {
            setError("Vehicle Registration Number is required");
            return;
        }

        try {
            const response = await axios.get(`${APP_SERVICES_URL}/sn-events-service/${CustID}/manualOffenderCheck?ocr=${licensePlate.toUpperCase()}`, {
                headers: {
                    Authorization: authHeader,
                    'Cache-Control': 'no-cache',
                },
            });

            if (response.status === 200) {
                const data = response.data;
                let type;
                if (data === IOU) {
                    type = "IOU";
                } else if (data === PREPAY) {
                    type = "Drive Off";
                } else if (data === STOLEN_PLATE) {
                    type = "Stolen Plate"
                }
                else {
                    type = "null";
                }
                setResponseType(type);
            } else {
                console.error('Error fetching rego data. HTTP status:', response.status);
                throw new Error('Failed to fetch rego data');
            }
        } catch (error) {
            console.error('Error fetching rego data:', error);
        }
    };
    const handleCloseRegoCheckModal = () => {
        onHide();
        setError("");
        setLicensePlate("");
        setResponseType(null)

    }
    return (
        <Modal show={show} onHide={handleCloseRegoCheckModal} fullscreen>
            <div className="modal-dialog modal-dialog-centered modal-fullscreen">
                <div className="modal-content" style={{ backgroundColor: '#212529', color: '#FFFFFF' }}>
                    <div className="modal-header">
                        <h3 className="modal-title" id="fullscreenModalLabel" style={{ fontSize: "1.2rem", fontWeight: "500", fontFamily: "Ethnocentric", color: '#ffffff' }}
                        >
                            Check Rego
                        </h3>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleCloseRegoCheckModal}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="rego-outer-container">
                            <div className="incident-tab step-1 connect-lookup">
                                <h5>Check suspicious vehicle</h5>
                                <p style={{ color: '#ADB5BD' }}>Enter the customer registration number to check if the vehicle is on the prepay list.</p>
                                <label style={{ color: '#ADB5BD' }} htmlFor="lookup-rego-input" className="form-label">Vehicle Registration Number</label>
                                <div className="input-group mb-3">
                                    <div className="col-sm-12 d-flex">
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                id="lookup-rego-input"
                                                className="form-control"
                                                style={{ backgroundColor: '#212529', color: '#ADB5BD', borderColor: "#ADB5BD", border: '1px solid #495057', marginBottom: '10px' }}
                                                aria-label="Sizing example input"
                                                aria-describedby="inputGroup-sizing-md"
                                                required
                                                value={licensePlate}
                                                onChange={handleInputChange} // Attach the input change event handler
                                                onInput={(e) => {
                                                    let newValue = e.target.value.replace(/\s/g, '');
                                                    newValue = newValue.slice(0, 10);
                                                    newValue = newValue.replace(/[^A-Za-z0-9]/g, '');
                                                    e.target.value = newValue.toUpperCase();
                                                }}
                                            />
                                        </div>
                                        <div className="col-sm-3">
                                            <button id="btn-lookup-search" style={{ float: 'left' }} className="btn btn-outline-primary" onClick={handleCheckRego}>Check rego</button>

                                        </div>
                                    </div>
                                </div>
                                <div id="lookup-rego-input-help" className="form-text" style={{ display: "none", color: "inherit" }}></div>
                            </div>
                            {error && <div className="error" style={{ color: 'red' }}>{error}</div>} {/* Display error message */}
                            {responseType && (
                                <div className="response-data">
                                    <h5 style={{ color: responseType === "IOU" ? "orange" : responseType === "Drive Off" ? "red" : responseType === "Stolen Plate" ? "rgba(225, 95, 95, 0.644)" : "green" }}>
                                        {responseType === "IOU" ? "This vehicle is a known offender" :
                                            responseType === "Drive Off" ? "This vehicle is a Drive Off" : responseType === "Stolen Plate" ? "This vehicle is a Stolen Plate" : "This vehicle is OK to pump"}
                                    </h5>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};
export default RegoCheckModal;